<template>
    <div id="list_container">
        <div class="list-box" :style="scrollView">
        <div class="main" v-if="show">
            <div v-if="cardList.length==0" style="    margin: auto;">
                <a-empty />
            </div>
            <div v-else   class="item" v-for="(item,index) in cardList " v-bind:key="index" @click="toClick(item)">
                <div class="normal-item">
                    <div class="header">
                         <div class="prefix">
                            <svg-icon name="知识库" style="margin-right:7px"></svg-icon>
                            {{ item.appName }}
                         </div>
                    </div>
                    <div class="desc">{{ item.description }}</div>
                    <div class="footer">
                        <div class="prefix"><svg-icon name="time" color="#999" style="margin-right: 2px;"/>
                            {{ item. createTime}}</div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
    </div>
  
</template>
<script setup>
import { onMounted } from 'vue';

import store from '@/store';
import { ref } from 'vue';
import router from '@/router';
import {toGetApp} from '@/untils/knowledege'
import { nextTick } from 'vue';
const scrollView=ref()
const cardList=ref([])
const show=ref(false)
 onMounted(async()=>{
    var height = document.getElementById('list_container').offsetHeight
    scrollView.value = { height: (height - 30) + 'px', overflow: 'auto' }
   if(store.getters.knowledgeAPPList.length==0){
    cardList.value= await toGetApp()
   
   }
  
    else  cardList.value= store.getters.knowledgeAPPList
    if(cardList.value.length==0){
        router.replace({ name: 'mainPage' })
    }
    nextTick(()=>{
        show.value=true
    })  
 })


 const toClick=(val)=>{
   
     var result = val.containers instanceof Array?val.containers:JSON.parse(val.containers )
    console.log(val,'toClick')
     router.push({path:'/knowledgeManageDetail',query:{knowId:val.id,containerId:result[0].id}})
 }
</script>
<style scoped  lang="less">

#list_container {
    width: 100%;
}
.list-box{
    width: 100%;
    height: 100%;
    overflow-y: auto;

 .main{
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 0;
    padding: 10px 0;
   
   
    .item{
    width: calc((100% - 100px) / 3);
    margin: 0 30px 0px 0;
    height: 165px;
    position: relative;
    box-sizing: border-box;
    transition: all .3s;  
      .normal-item{
        width: 100%;
        max-height: 165px;
        padding: 15px;
        background: #f8f8f8;
        border-radius: 8px;
        cursor: pointer;
        box-sizing: border-box;
        position: absolute;
        z-index: 1;
        display: grid;
        transition: all .3sease-out;
        border: 1px solid #f8f8f8;
     .header{
            display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 10px;
        line-height: 20px;

         .prefix{
            flex: 1;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    font-size: 16px;
    color: #333;
    font-weight: 600;
    display: flex;
           align-items: center
         }
     }
     .desc{
        white-space: wrap;
    text-overflow: clip;
    display: block;
    font-size: 14px;
    line-height: 24px;
    min-height: 48px;
    color: #505050;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
     }
     .footer{
        height: 14px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #999;
    font-size: 12px;
   
    .prefix{
        display: flex;
    align-items: center;
    }
     }
      }
    }
    .item:hover{
         .normal-item{
            background: #ffffff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 4px 5px rgba(0, 0, 0, .08), 0 1px 10px rgba(0, 0, 0, .05);
    border-color: #19a2cd;
    max-height: 600px;
    grid-template-rows: 1fr;
         }
    }

 }
}
</style>